export default __webpack_public_path__ + "static/media/team3.4b721175.jpg";